
import { styled } from '@mui/material';
export const StyledWhatIs = styled('section')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 992px) {
    flex-wrap: wrap;
    justify-content: center;
  }
`;
export const StyledWhatIsMain = styled('section')`
    margin-top: 100px;
    @media (max-width: 480px) {
        margin-top: 60px;
    }
    h2 {
        font-size: 48px;
        font-weight: 500;
        font-family: "YesevaOne", serif;
        color: #2B2B2B;
        text-align: center;
        @media (max-width: 725px) {
            text-align: center;
            line-height: 54px;
        }
        @media (max-width: 480px) {
            font-size: 26px;
            line-height: 29px;
        }
    }
    h4 {
        font-size: 28px;
        font-weight: 700;
        text-align: left;
        @media (max-width: 480px) {
            font-size: 24px;
        }
    }
    p {
        margin-top: 12px;
        font-family: "CormorantInfant", serif;
        font-size: 24px;
        font-weight: 400;
        color: #2B2B2B;
        text-align: center;
        margin-bottom: 20px !important;
        @media (max-width: 992px) {
            text-align: center;
        }
        @media (max-width: 480px) {
            font-size: 18px;
            line-height: 24px;
        }
    }
    span {
        font-size: 18px;
        font-weight: 300;
        color: #fff;
        opacity: 0.8;
    }
`;

export const HeadingWhatIs = styled('div')`
  max-width: 697px;
  width: 100%;
  ul {
    margin-left: 15px;
    li {
        padding-bottom: 10px;
    }
  }
  h2 {
    font-size: 48px;
    font-weight: 700;
    text-align: left;
    line-height: 1.1;
    font-family: "YesevaOne", serif;
    @media (max-width: 725px) {
      text-align: center;
      line-height: 54px;
    }
    @media (max-width: 480px) {
      font-size: 26px;
      line-height: 29px;
    }
  }
  p {
    margin-top: 12px;
    font-family: "Manrope", serif;
    font-size: 18px;
    font-weight: 400;
    background: radial-gradient(circle, #3ACACF 20%, #3c5dfe 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    line-height: 30px;
    span {
        padding-bottom: 5px;
        display: block;
        white-space: pre-line;
    }
    @media (max-width: 992px) {
      text-align: center;
    }
    @media (max-width: 480px) {
      font-size: 18px;
      line-height: 24px;
    }
  }
  a {
    color: #4b4b4b !important;
    text-decoration: underline;
    :hover {
      color: #4b4b4b !important;
      text-decoration: none;
    }
  }
`;

export const VideoWhatIs = styled('div')`
  display: flex;
  align-items: center;
`;
export const TextWrapper = styled('div')`
  h4 {
    font-size: 24px;
    font-family: "Tektur", serif;
    font-weight: 400;
    text-align: center;
    margin-bottom: 6px;
    @media (max-width: 480px) {
      font-size: 18px;
      text-align: left;
      line-height: 24px;
    }
  }
  span {
    font-size: 18px;
    font-weight: 300;
    color: #4b4b4b;
    opacity: 0.8;
    @media (max-width: 480px) {
      font-size: 15px;
      text-align: left;
    }
  }
`;
